import React, { useState } from 'react';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export default function MakeAdmin() {
  const [uid, setUid] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  async function handleMakeAdmin(e) {
    e.preventDefault();
    setError('');
    setResult(null);
    setLoading(true);

    try {
      const makeUserAdmin = httpsCallable(functions, 'makeUserAdmin');
      const response = await makeUserAdmin({ uid: uid.trim() });
      setResult(response.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Make User Admin</h1>
        <p className="text-sm text-gray-600 mb-6">
          This is a helper page for testing. Enter a Firebase Auth UID to grant admin privileges.
        </p>

        <form onSubmit={handleMakeAdmin} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              User UID
            </label>
            <input
              type="text"
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              required
              placeholder="abc123def456..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-500 mt-1">
              Get UID from Firebase Console → Authentication → Users
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Processing...' : 'Make Admin'}
          </button>
        </form>

        {result && (
          <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded">
            <p className="text-green-800 font-medium">✅ Success!</p>
            <p className="text-sm text-green-700 mt-1">{result.message}</p>
            <p className="text-xs text-green-600 mt-2">
              Now you can <a href="/login" className="underline">login</a> as admin.
            </p>
          </div>
        )}

        {error && (
          <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded">
            <p className="text-red-800 font-medium">❌ Error</p>
            <p className="text-sm text-red-700 mt-1">{error}</p>
          </div>
        )}

        <div className="mt-6 pt-6 border-t border-gray-200">
          <h2 className="text-sm font-medium text-gray-700 mb-2">Quick Steps:</h2>
          <ol className="text-xs text-gray-600 space-y-1 list-decimal list-inside">
            <li>Create user in Firebase Console</li>
            <li>Copy the User UID</li>
            <li>Paste it above and click "Make Admin"</li>
            <li>Login at <a href="/login" className="text-blue-600 underline">/login</a></li>
          </ol>
        </div>
      </div>
    </div>
  );
}
